<template>
  <div id="financial" class="users f-c-b f-d-c w-100 h-100">
    <div class="f-s-s f-d-c w-100">
      <div v-if="user.is_organ == 'yes'" class="f-c-s w-100 searchLine mb-5">
        <div class="label f-c-c ml-2">سازمان :</div>
        <select class="sessionGroup" v-model="groupSelected">
          <option v-for="(v, i) in allUserOrg.organ_list" :key="i" :value="v.id">
            {{ v.title }}
          </option>
        </select>
      </div>
      <div class="w-100 f-s-c f-d-c">
        <div class="downSec w-100 f-s-c f-d-c">
          <div class="header f-c-b w-100 mb-3">
            <div class="f-c-b searchBox w-100">
              <div class="tableTitle f-c-c">
                طرح های من
                <!-- <img
                  class="info"
                  :src="require(`@/assets/images/home/info.png`)"
                  alt="راهنما"
                  title="راهنما"
                /> -->
              </div>
              <!-- <div class="tableTitle f-c-c">تاریخچه افزایش اعتبار</div> -->
              <div class="f-c-c">
                <div class="search f-c-c">
                  <input
                    v-if="isSearchActive"
                    :class="[isSearchActive ? 'searchInputActive pb-0' : '']"
                    @keyup="searchFunc"
                    type="text"
                    placeholder="جستجو"
                  />
                  <b-img
                    :class="[isSearchActive ? 'imgActive' : '']"
                    :src="require(`@/assets/images/gap/search-icon.svg`)"
                    @click="searchIconFunc()"
                  ></b-img>
                </div>
                <div class="addNewSubj f-c-c" @click="addNewPelan()">
                  <span class="plus ml-2">+</span>
                  <div class="text f-c-c">خرید طرح</div>
                </div>
              </div>
            </div>
          </div>
          <div class="userTable f-c-c f-d-c w-100 mt-2">
            <div class="header f-c-s w-100">
              <div class="headerItem f-c-s"></div>
              <div class="headerItem f-c-s w-40">عنوان</div>
              <div class="headerItem f-c-s w-30">تعداد کاربران</div>
              <div class="headerItem f-c-s w-30">باقیمانده طرح</div>
            </div>
            <div
              v-if="itemsForList.length"
              class="tableContent f-c-c f-d-c w-100"
            >
              <div
                v-for="(v, i) in itemsForList"
                :key="i"
                class="tableRow f-c-s w-100"
              >
                <div class="tableItem f-c-c">{{ v.row }}</div>
                <div class="tableItem f-c-s w-40">
                  {{ v.title ? v.title : "-" }}
                </div>
                <div class="tableItem f-c-s w-30">
                  {{ v.max_user_count ? v.max_user_count : "-" }}
                </div>
                <div class="tableItem f-c-s w-30">
                  {{ v.remaining_days ? v.remaining_days : "-" }}
                </div>
              </div>
            </div>
            <div v-else class="tableContent emptyTable f-c-c w-100 h-100">
              طرحی خریداری نشده است.
            </div>
            <div class="paginationSection f-c-c w-100">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
          <div
            v-if="mobilePlansList && mobilePlansList.length"
            class="mobileUserTable f-c-s f-d-c w-100"
          >
            <div
              v-for="(v, i) in mobilePlansList"
              :key="i"
              class="tableItem f-c-s f-d-c w-100 mb-3"
            >
              <div class="up f-c-b w-100 mb-3">
                <div class="right f-s-s f-d-c">
                  <div class="labelItem f-c-c mb-2">عنوان :</div>
                  <div class="labelItem f-c-c mb-2">تعداد کاربران :</div>
                  <div class="labelItem f-c-c mb-2">باقیمانده طرح :</div>
                </div>
                <div class="left f-e-e f-d-c">
                  <div class="answerItem f-c-e mb-2">
                    {{ v.title }}
                  </div>
                  <div class="answerItem f-c-e mb-2">
                    {{ v.max_user_count }}
                  </div>
                  <div class="answerItem f-c-e mb-2">
                    {{ v.remaining_days }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="mobileUserTable tableContent emptyTable f-c-c w-100 h-100"
          >
            طرحی خریداری نشده است.
          </div>
        </div>
        <div class="downSec w-100 f-s-c f-d-c">
          <div class="header f-c-b w-100 mb-3">
            <div class="f-c-b searchBox w-100">
              <div class="tableTitle f-c-c">بسته های من</div>
              <div class="f-c-c">
                <div class="search f-c-c">
                  <input
                    v-if="isSearchActive2"
                    :class="[isSearchActive2 ? 'searchInputActive pb-0' : '']"
                    @keyup="searchFunc2"
                    type="text"
                    placeholder="جستجو"
                  />
                  <b-img
                    :class="[isSearchActive2 ? 'imgActive' : '']"
                    :src="require(`@/assets/images/gap/search-icon.svg`)"
                    @click="searchIconFunc2()"
                  ></b-img>
                </div>
                <div class="addNewSubj f-c-c" @click="addNewPackege()">
                  <span class="plus ml-2">+</span>
                  <div class="text f-c-c">خرید بسته</div>
                </div>
              </div>
            </div>
          </div>
          <div class="userTable f-c-c f-d-c w-100 mt-2">
            <div class="header f-c-s w-100">
              <div class="headerItem f-c-s"></div>
              <div class="headerItem f-c-s w-50">نوع بسته</div>
              <div class="headerItem f-c-s w-50">باقی مانده بسته</div>
            </div>
            <div
              v-if="itemsForList2.length"
              class="tableContent f-c-c f-d-c w-100"
            >
              <div
                v-for="(v, i) in itemsForList2"
                :key="i"
                class="tableRow f-c-s w-100"
              >
                <div class="tableItem f-c-c">{{ v.row }}</div>
                <div class="tableItem f-c-s w-50">
                  {{ v.service_type ? v.service_type : "-" }}
                </div>
                <div class="tableItem f-c-s w-50">
                  {{ v.remained_value ? v.remained_value : "-" }}
                </div>
              </div>
            </div>
            <div v-else class="tableContent emptyTable f-c-c w-100 h-100">
              بسته ای خریداری نشده است.
            </div>
            <div class="paginationSection f-c-c w-100">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
          <div
            v-if="mobilePackegList && mobilePackegList.length"
            class="mobileUserTable f-c-s f-d-c w-100"
          >
            <div
              v-for="(v, i) in mobilePackegList"
              :key="i"
              class="tableItem f-c-s f-d-c w-100 mb-3"
            >
              <div class="up f-c-b w-100 mb-3">
                <div class="right f-s-s f-d-c">
                  <div class="labelItem f-c-c mb-2">نوع بسته :</div>
                  <div class="labelItem f-c-c mb-2">باقی مانده بسته :</div>
                </div>
                <div class="left f-e-e f-d-c">
                  <div class="answerItem f-c-e mb-2">
                    {{ v.service_type }}
                  </div>
                  <div class="answerItem f-c-e mb-2">
                    {{ v.remained_value }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="mobileUserTable tableContent emptyTable f-c-c w-100 h-100"
          >
            بسته ای خریداری نشده است.
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="upSec w-100 f-c-b">
      <div class="rightSec f-c-s f-d-c">
        <div class="title w-100 f-c-s mb-4">افزایش اعتبار</div>
        <div class="input w-100 f-s-s f-d-c mb-3">
          <div class="label w-100 f-c-s">
            مبلغ
            <span class="unit f-c-c">(تومان)</span>
            <span class="required">*</span>
          </div>
          <select v-model="price">
            <option value="0">مبلغ خود را انتخاب کنید</option>
            <option
              v-for="(v, i) in paymentList.information"
              :key="i"
              :value="v.value"
            >
              {{ v.title }}
            </option>
            <option value="custom">مبلغ دلخواه</option>
          </select>
        </div>
        <div
          class="input w-100 f-s-s f-d-c mb-3"
          :class="[isCustom ? 'noCustom' : '']"
        >
          <div class="label w-100 f-c-s">
            مبلغ دلخواه
            <span class="unit f-c-c">(تومان)</span>
          </div>

          <input
            :disabled="isCustom"
            v-model="customPrice"
            @keyup="separate(customPrice)"
            type="text"
          />
        </div>
        <div class="btnSec w-100 f-c-s">
          <div @click="payPriceFunc()" class="btn f-c-c">پرداخت</div>
        </div>
      </div>
      <div class="rightSec f-c-s f-d-c">
        <div class="title w-100 f-c-s mb-3">ارسال فیش بانکی</div>
        <div class="dropDownSec w-100 h-100 f-s-s f-d-c">
          <div class="label w-100 f-c-s mb-2">
            تصویر فیش
            <span class="required">*</span>
          </div>
          <b-form-file
            @input="addFileFunc"
            ref="file-input"
            accept="image/*,.jpg, .png,.pdf"
            placeholder=""
          >
            <template slot="placeholder">
              <b-img :src="require(`@/assets/images/gap/bill.png`)"></b-img>
              <div class="text f-c-c">
                <div class="value f-c-c" style="color: #125488">
                  {{ "فیش خود را بارگذاری نمایید..." }}
                </div>
              </div>
            </template>
          </b-form-file>
          <div v-if="file" class="deleteFileSec w-100 f-c-e">
            <span class="deleteItem f-c-c ml-1" @click="deleteFileFunc()"
              >x</span
            >
            {{ fileName }}
          </div>
        </div>
        <div class="btnSec w-100 f-c-s">
          <div @click="sendPaymentBillFunc()" class="btn f-c-c">ثبت</div>
        </div>
      </div>
    </div> -->

    <div class="gapMaterial f-c-c w-100">
      <div class="text blueText f-c-c">
        کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می
        باشد.
      </div>
    </div>
    <b-modal
      id="edit-modal"
      title="توجه"
      button-size="sm"
      size="lg"
      :hide-footer="footer"
      ref="info-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="f-c-c f-d-c mb-5 mt-3">
          <h4>کاربر گرامی</h4>
          <br />
          <p>
            به اطلاع می رساند از تاریخ 10 خرداد ماه استفاده از سامانه منوط به
            خرید طرح های تعیین شده می باشد.
          </p>
          <br />
          <div>
            لینک خرید :
            <a href="https://vadaroom.ec.iau.ir/my-gap/finance-list"
              >https://vadaroom.ec.iau.ir/my-gap/finance-list</a
            >
          </div>
        </div>
        <div class="btnSec w-100 f-c-c mb-3">
          <div class="finalbtn f-c-c m-0" @click="confirmFunc()">تایید</div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "FinanceList",
  data() {
    return {
      groupSelected: "",
      price: "0",
      customPrice: "",
      file: null,
      fileName: "",
      isCustom: true,
      footer: true,
      isSearchActive: false,
      isSearchActive2: false,
      currentPage: 1,
      currentPage2: 1,
      perPage: 15,
      perPage2: 15,
      mobileGroupList: [],
      groupList: [],
      plansList: [],
      mobilePlansList: [],
      packegList: [],
      mobilePackegList: [],
    };
  },
  created() {
    if (this.user.is_organ == "yes") {
      this.getAllUserOrgFunction({
        user_id: this.user.user_id,
      });
    } else {
      this.getOrganPackagesPlansListFunction({
        user_id: this.user.user_id,
        organ_id: 0,
      });
    }

    // this.getPaymentListFunction({
    //   user_id: this.user.user_id,
    // });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      allUserOrg: (state) => state.gap.allUserOrg,
      paymentList: (state) => state.gap.paymentList,
      onlinePaymentStatus: (state) => state.gap.onlinePaymentStatus,
      paymentBillStatus: (state) => state.gap.paymentBillStatus,
      organCreditList: (state) => state.gap.organCreditList,
      packagesPlansList: (state) => state.gap.packagesPlansList,
    }),
    rows() {
      if (this.plansList) {
        return this.plansList.length;
      } else {
        return 0;
      }
    },
    itemsForList() {
      if (this.plansList) {
        return this.plansList.slice(
          (this.currentPage - 1) * this.perPage,
          this.currentPage * this.perPage
        );
      } else {
        return [];
      }
    },
    rows2() {
      if (this.packegList) {
        return this.packegList.length;
      } else {
        return 0;
      }
    },
    itemsForList2() {
      if (this.packegList) {
        return this.packegList.slice(
          (this.currentPage2 - 1) * this.perPage2,
          this.currentPage2 * this.perPage2
        );
      } else {
        return [];
      }
    },
  },
  components: {},
  methods: {
    ...mapActions("gap", [
      "getOrganCreditListFunction",
      "getAllUserOrgFunction",
      "getPaymentListFunction",
      "onlinePaymentFunction",
      "paymentBillFunction",
      "getOrganPackagesPlansListFunction",
      "setOrganSelectForBuyPelanFunction",
    ]),
    addNewPackege() {
      this.setOrganSelectForBuyPelanFunction(this.groupSelected);
      this.$router.push({ name: "packages" });
    },
    addNewPelan() {
      this.setOrganSelectForBuyPelanFunction(this.groupSelected);
      this.$router.push({ name: "plans" });
    },
    sendPaymentBillFunc() {
      if (this.file) {
        this.paymentBillFunction({
          user_id: this.user.user_id,
          bill: this.file,
          organ_id: this.groupSelected,
        });
      } else {
        this.$bvToast.toast("فایلی ارسال نشده است.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      }
    },
    payPriceFunc() {
      if (this.price !== "0" && this.price !== "custom") {
        this.onlinePaymentFunction({
          user_id: this.user.user_id,
          amount: this.price,
          organ_id: this.groupSelected,
        });
      } else if (this.price == "custom" && this.customPrice) {
        let m = this.customPrice.replaceAll(",", "");
        let isnum = /^\d+$/.test(m);
        if (isnum) {
          this.onlinePaymentFunction({
            user_id: this.user.user_id,
            amount: this.customPrice,
            organ_id: this.groupSelected,
          });
        } else {
          this.$bvToast.toast("مبلغ را صحیح وارد نمایید.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      } else {
        this.$bvToast.toast("مبلغی را انتخاب نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      }
    },
    searchFunc(v) {
      let n = v.target.value;
      let searchArray = this.packagesPlansList.organ_plan.filter((ticket) => {
        return (
          ticket.title.toLowerCase().includes(n) ||
          ticket.max_user_count.toLowerCase().includes(n) ||
          ticket.remaining_days.toLowerCase().includes(n)
        );
      });
      this.plansList = searchArray;
      this.mobilePlansList = searchArray;
    },
    searchFunc2(v) {
      let n = v.target.value;
      let searchArray = this.packagesPlansList.organ_package.filter(
        (ticket) => {
          return (
            ticket.remained_value.toLowerCase().includes(n) ||
            ticket.service_type.toLowerCase().includes(n)
          );
        }
      );
      this.packegList = searchArray;
      this.mobilePackegList = searchArray;
    },
    searchIconFunc() {
      this.isSearchActive = !this.isSearchActive;
      setTimeout(() => {
        if (this.isSearchActive) {
          document.querySelector(".searchInputActive").focus();
        }
      }, 200);
    },
    searchIconFunc2() {
      this.isSearchActive2 = !this.isSearchActive2;
      setTimeout(() => {
        if (this.isSearchActive2) {
          document.querySelector(".searchInputActive2").focus();
        }
      }, 200);
    },
    separate(x) {
      let m = x.replaceAll(",", "");
      this.customPrice = m.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    addFileFunc(e) {
      if (e) {
        if (e.size > 2000000) {
          this.$bvToast.toast("فایل ارسالی باید کمتر از 2 مگابایت باشد.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
          this.deleteFileFunc();
        } else {
          this.fileName = e.name;
          this.file = e;
        }
      }
    },
    deleteFileFunc() {
      this.$refs["file-input"].reset();
      this.file = null;
      this.fileName = "";
    },
  },
  watch: {
    organCreditList(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.groupList = n.organ_credit_list;
          this.mobileGroupList = n.organ_credit_list;
        } else {
          this.groupList = [];
          this.mobileGroupList = [];
        }
      }
    },
    packagesPlansList(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.plansList = n.organ_plan;
          this.mobilePlansList = n.organ_plan;
          this.packegList = n.organ_package;
          this.mobilePackegList = n.organ_package;
        } else {
          this.plansList = [];
          this.mobilePlansList = [];
          this.packegList = [];
          this.mobilePackegList = [];
        }
      }
    },
    allUserOrg(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.groupSelected = n.organ_list[0].id;
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    onlinePaymentStatus(n) {
      if (Object.keys(n).length) {
        this.isCustom = true;
        this.price = "";
        this.customPrice = "";
        if (n.code == 100) {
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    paymentBillStatus(n) {
      if (Object.keys(n).length) {
        this.file = null;
        this.fileName = "";
        this.$refs["file-input"].reset();
        if (n.code == 100) {
          this.getOrganCreditListFunction({
            user_id: this.user.user_id,
            organ_id: this.groupSelected,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    groupSelected(n) {
      this.getOrganCreditListFunction({
        user_id: this.user.user_id,
        organ_id: n,
      });
      this.getOrganPackagesPlansListFunction({
        user_id: this.user.user_id,
        organ_id: n,
      });
    },
    price(n) {
      if (n == "custom") {
        this.isCustom = false;
      } else {
        this.isCustom = true;
      }
    },
  },
  mounted() {},
};
</script>